import { ApolloError } from "@apollo/client";
import { PROJECT_CATCH_ERROR_LIST, handleLogout } from "@platformx/utilities";
import graphqlInstance from "../../config/graphqlConfig";
import axiosInstance from "../../config/restApiConfig";
import { AuthQueries } from "../../graphQL/queries/authQueries";

const authAPI = {
  verifySession: async (url: string) => {
    try {
      const res = await axiosInstance.get(process.env.NX_PUBLIC_API_URI + url, {
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        withCredentials: true,
      });
      return res.data;
    } catch (err: any) {
      if (err?.response?.data?.code === 401 && !url.includes("verify")) {
        handleLogout();
      }
      return err;
    }
  },
  signIn: async (url: string, payload = {}) => {
    try {
      const res = await axiosInstance.post(process.env.NX_PUBLIC_API_URI + url, payload, {
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        withCredentials: true,
      });
      return res.data.result ? res.data.result : res.data;
    } catch (err: any) {
      if (err?.response?.data?.code === 401) {
        handleLogout();
      }
      return err;
    }
  },
  fetchRoles: async (input: any): Promise<any> => {
    try {
      const { data } = await graphqlInstance.query({
        query: AuthQueries.FETCH_PERMISSIONS,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return data?.authoring_permissionList || null;
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchRoles`, err);
      if (err instanceof ApolloError) throw err;
    }
  },
  fetchBrandDetails: async (): Promise<{ brandId: string; brandName: string }[]> => {
    try {
      const { data } = await graphqlInstance.query({
        query: AuthQueries.FETCH_BRAND_DETAILS,
        fetchPolicy: "no-cache",
      });

      const brandDetailsData = data?.authoring_getBrandDetails;
      const multiBrandsEnabled =
        brandDetailsData?.multi_brands_enabled === true ||
        brandDetailsData?.multi_brands_enabled === "true";

      if (typeof localStorage === "object") {
        localStorage.setItem("multiBrandsEnabled", String(multiBrandsEnabled));
      }

      if (!multiBrandsEnabled) {
        if (typeof localStorage === "object") {
          localStorage.removeItem("multiBrandsList");
        }
        return [];
      }

      const rawBrands = brandDetailsData?.multi_brands;
      if (!Array.isArray(rawBrands)) return [];

      const normalizedBrands = rawBrands
        .map((brand: any) => ({
          brandId: String(brand?.brandId ?? brand?.brand_id ?? brand?.id ?? "").trim(),
          brandName: String(brand?.brandName ?? brand?.brand_name ?? brand?.name ?? "").trim(),
        }))
        .filter((brand: { brandId: string; brandName: string }) =>
          Boolean(brand.brandId && brand.brandName),
        );

      if (typeof localStorage === "object") {
        localStorage.setItem("multiBrandsList", JSON.stringify(normalizedBrands));
      }

      return normalizedBrands;
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchBrandDetails`, err);
      return [];
    }
  },
};
export default authAPI;
